const NEW_OBJECT_TYPE = 'newObjectType'
const NEW_OBJECT_TYPE_GROUP = 'newObjectTypeGroup'
const NEW_COLLECTION_TYPE = 'newCollectionType'
const NEW_DATA_SET_TYPE = 'newDataSetType'
const NEW_VOCABULARY_TYPE = 'newVocabularyType'
const NEW_USER = 'newUser'
const NEW_USER_GROUP = 'newUserGroup'
const NEW_DYNAMIC_PROPERTY_PLUGIN = 'newDynamicPropertyPlugin'
const NEW_ENTITY_VALIDATION_PLUGIN = 'newEntityValidationPlugin'
const NEW_QUERY = 'newQuery'
const SPACES = 'spaces'
const NEW_SPACE = 'newSpace'
const NEW_PROJECT = 'newProject'
const NEW_COLLECTION = 'newCollection'
const NEW_OBJECT = 'newObject'
const NEW_DATA_SET = 'newDataSet'

const SPACE = 'space'
const PROJECT = 'project'
const OBJECT = 'object'
const OBJECT_TYPE = 'objectType'
const OBJECT_TYPE_GROUP = 'objectTypeGroup'
const COLLECTION = 'collection'
const COLLECTION_TYPE = 'collectionType'
const DATA_SET = 'dataSet'
const DATA_SET_TYPE = 'dataSetType'
const VOCABULARY_TYPE = 'vocabularyType'
const PROPERTY_TYPE = 'propertyType'
const USER = 'user'
const USER_GROUP = 'userGroup'
const DYNAMIC_PROPERTY_PLUGIN = 'dynamicPropertyPlugin'
const ENTITY_VALIDATION_PLUGIN = 'entityValidationPlugin'
const PERSONAL_ACCESS_TOKEN = 'personalAccessToken'
const QUERY = 'query'
const HISTORY = 'history'
const IMPORT = 'import'
const REPORT = 'report'
const ACCESS = 'access'
const ACTIVE_USERS_REPORT = 'activeUsersReport'
const TRASHCAN = 'trashcan'

const SEARCH = 'search'
const OVERVIEW = 'overview'

export default {
  NEW_OBJECT_TYPE,
  NEW_OBJECT_TYPE_GROUP,
  NEW_COLLECTION_TYPE,
  NEW_DATA_SET_TYPE,
  NEW_VOCABULARY_TYPE,
  NEW_USER,
  NEW_USER_GROUP,
  NEW_DYNAMIC_PROPERTY_PLUGIN,
  NEW_ENTITY_VALIDATION_PLUGIN,
  NEW_QUERY,
  SPACES,
  NEW_SPACE,
  NEW_PROJECT,
  NEW_COLLECTION,
  NEW_OBJECT,
  NEW_DATA_SET,
  SPACE,
  PROJECT,
  OBJECT,
  OBJECT_TYPE,
  OBJECT_TYPE_GROUP,
  COLLECTION,
  COLLECTION_TYPE,
  DATA_SET,
  DATA_SET_TYPE,
  VOCABULARY_TYPE,
  PROPERTY_TYPE,
  USER,
  USER_GROUP,
  DYNAMIC_PROPERTY_PLUGIN,
  ENTITY_VALIDATION_PLUGIN,
  PERSONAL_ACCESS_TOKEN,
  QUERY,
  HISTORY,
  IMPORT,
  REPORT,
  ACCESS,
  SEARCH,
  OVERVIEW,
  ACTIVE_USERS_REPORT,
  TRASHCAN
}
